class EmptyTab extends React.Component<any, any> {
    public render(): JSX.Element {
        return <div />;
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }
}

export { EmptyTab };
